import { FunctionComponent, useState } from "react";
import { MultiStepProgress } from "../../components/MultiStepProgress";
import { ButtonRound, ButtonSquare } from "../../components/basic/Buttons";
import { FormExtraItem } from "../../components/FormExtraItem";
import styles from "./Demo.module.scss";
import {
  startLoading,
  endLoading,
} from "../../components/basic/LoadingProgress/loadingProgressSlice";
import { useAppDispatch } from "../../app/hooks";
import { showNotification } from "../../components/basic/NotificationBar/notificationBarSlice";
import { SelectComponent } from "../../components/basic/Select";
import { CheckboxComponent as Checkbox } from "../../components/basic/Checkbox";
import { RadioComponent } from "../../components/basic/Radio";
import { SwitchComponent } from "../../components/basic/Switch";
import { TextFieldComponent } from "../../components/basic/TextField";
import { Collapsible } from "../../components/basic/Collapsible";
import { CompoundSlider } from "@/components/basic/Slider";
import { Formik } from "formik";
import { Slider } from "@rmwc/slider";
import "@rmwc/slider/styles";

const progress = [
  "Info For KH51 CAM",
  "Customise & Options",
  "Review & Payment",
  "Last Page",
];

const Demo: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const [activeItem, setActive] = useState(0);
  const [checkedItem, setChecked] = useState(false);
  const [radioItem, setRadioItem] = useState("cookie");
  const [switchValue, setSwitchValue] = useState(false);
  const [textValue, setTextValue] = useState("Text String");
  const [invalid, setInvalid] = useState(false);
  const [value, setValue] = useState(50);

  const sliderExample = () => {
    return (
      <Slider
        value={value}
        onChange={(evt) => setValue(evt.detail.value)}
        onInput={(evt) => setValue(evt.detail.value)}
        discrete
        step={1}
      />
    );
  };

  const Basic = () => (
    <div>
      <Formik
        initialValues={{ email: "admin@car.co.uk", password: "123456" }}
        validate={(values) => {
          const errors: { email?: string } = {};
          if (!values.email) {
            errors.email = "Required";
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = "Invalid email address";
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          dispatch(startLoading());
          setTimeout(() => {
            setSubmitting(false);
            dispatch(
              showNotification(
                "Lorem ipsum dolor sit amet consectetur adipisicing elit"
              )
            );
            dispatch(endLoading());
          }, 600);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          setSubmitting,
          submitForm,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <TextFieldComponent
              label="Email Field"
              value={values.email}
              onChange={(e) => setFieldValue("email", e.currentTarget.value)}
              errorMsg={errors.email}
            />
            <TextFieldComponent
              label="Password"
              value={values.password}
              onChange={(e) => setFieldValue("password", e.currentTarget.value)}
              errorMsg={errors.password}
              type="password"
            />

            <ButtonSquare
              text="Loading End"
              style={{ padding: "0 3rem" }}
              type="primary"
              onClick={() => {
                setSubmitting(true);
                submitForm();
              }}
              disabled={isSubmitting}
            />
          </form>
        )}
      </Formik>
    </div>
  );

  return (
    <div className={styles.demoPage}>
      <MultiStepProgress stepNames={progress} page={1} />
      <div style={{ marginTop: "3rem" }}>
        <ButtonRound
          text="Loading Start......"
          style={{ padding: "0 3rem" }}
          type="warning"
          onClick={() => {
            console.log("click");
            dispatch(startLoading());
          }}
        />
        <ButtonSquare
          text="Loading End"
          style={{ padding: "0 3rem" }}
          type="danger"
          onClick={() => {
            console.log("click");
            dispatch(endLoading());
          }}
        />
        <ButtonRound
          text="Notification"
          style={{ padding: "0 3rem" }}
          onClick={() => {
            dispatch(
              showNotification(
                "Lorem ipsum dolor sit amet consectetur adipisicing elit"
              )
            );
          }}
        />
        <ButtonRound
          text="Set Text Field Valid"
          style={{ padding: "0 3rem" }}
          type="danger"
          onClick={() => {
            setInvalid(!invalid);
          }}
        />
      </div>
      <div className="mt-10 h-20 px-4">
        <CompoundSlider
          domain={[0, 50]}
          value={30}
          onValueChange={(e) => console.log(e)}
        />
      </div>
      <div
        style={{
          marginTop: "3rem",
          flexWrap: "wrap",
          justifyContent: "space-around",
        }}
        className="d-flex align-center"
      >
        <div style={{ width: "30rem", marginTop: "1rem" }}>
          <FormExtraItem
            icon="security"
            title="Special Delivery Guranteed"
            price="Only ￡10.95"
            description="Lorem ipsum dolor sit amet consectetur adipisicing elit Lorem ipsum dolor sit amet consectetur adipisicing elit"
            active={activeItem === 0}
            onClick={() => setActive(0)}
          />
        </div>
        <div style={{ width: "30rem", marginTop: "1rem" }}>
          <FormExtraItem
            icon="star"
            title="Special Delivery Guranteed"
            price="Only ￡10.95"
            description="Lorem ipsum dolor sit amet consectetur adipisicing elit Lorem ipsum dolor sit amet consectetur adipisicing elit"
            active={activeItem === 1}
            onClick={() => setActive(1)}
          />
        </div>
        <div style={{ width: "30rem", marginTop: "1rem" }}>
          <FormExtraItem
            icon="minor_crash"
            title="Special Delivery Guranteed"
            price="Only ￡10.95"
            description="Lorem ipsum dolor sit amet consectetur adipisicing elit Lorem ipsum dolor sit amet consectetur adipisicing elit"
            active={activeItem === 2}
            onClick={() => setActive(2)}
          />
        </div>
      </div>
      <div
        style={{
          marginTop: "3rem",
          flexWrap: "wrap",
          justifyContent: "space-around",
        }}
        className="d-flex align-center"
      >
        <div style={{ width: "30rem", marginTop: "1rem" }}>
          {sliderExample()}
          <div style={{ width: "10rem" }}>
            <SelectComponent
              label="Text"
              onChange={(e: React.FormEvent<HTMLSelectElement>) =>
                console.log(e)
              }
              options={["Cookies", "Pizza", "Icecream"]}
            />
          </div>
        </div>
        <Checkbox
          label="Cookies"
          checked={checkedItem}
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            console.log(e);
            setChecked(!checkedItem);
          }}
        />
        <RadioComponent
          label="Cookie"
          checked={radioItem === "cookie"}
          onChange={(e) => {
            console.log(e);
            setRadioItem("cookie");
          }}
        />
        <RadioComponent
          label="Pizza"
          checked={radioItem === "Pizza"}
          onChange={(e) => {
            console.log(e);
            setRadioItem("Pizza");
          }}
        />
        <RadioComponent
          label="Icecream"
          checked={radioItem === "Icecream"}
          onChange={(e) => {
            console.log(e);
            setRadioItem("Icecream");
          }}
        />
        <SwitchComponent
          label="Switch Value"
          checked={switchValue}
          onChange={(e) => {
            console.log(e);
            setSwitchValue(!switchValue);
          }}
        />
      </div>
      <div
        style={{
          marginTop: "3rem",
          flexWrap: "wrap",
          justifyContent: "space-around",
        }}
        className="d-flex align-center"
      >
        <TextFieldComponent
          label="Normal Field"
          value={textValue}
          onChange={(e) => setTextValue(e.currentTarget.value)}
          errorMsg="Invalid field value."
        />
        <TextFieldComponent label="Datetime Local" type="datetime-local" />
        <TextFieldComponent
          label="With Icons"
          value={textValue}
          onChange={(e) => setTextValue(e.currentTarget.value)}
          icon="search"
          trailingIcon="close"
          onTrailingClick={() => console.log(setTextValue(""))}
        />
      </div>
      <div
        style={{
          marginTop: "3rem",
          flexWrap: "wrap",
          justifyContent: "space-around",
        }}
        className="d-flex align-center"
      >
        <div className="d-flex">
          <Collapsible
            text="Finance avaliable - no deposit to pay!"
            graphic="savings"
          >
            <div style={{ padding: "1rem" }}>
              <FormExtraItem
                icon="minor_crash"
                title="Special Delivery Guranteed"
                price="Only ￡10.95"
                description="Lorem ipsum dolor sit amet consectetur adipisicing elit Lorem ipsum dolor sit amet consectetur adipisicing elit"
                active={true}
              />
              <FormExtraItem
                icon="star"
                title="Special Delivery Guranteed"
                price="Only ￡10.95"
                description="Lorem ipsum dolor sit amet consectetur adipisicing elit Lorem ipsum dolor sit amet consectetur adipisicing elit"
                active={false}
                style={{ marginTop: "1rem" }}
              />
            </div>
          </Collapsible>
          <Collapsible
            text="How much will L2 cost?"
            graphic="help_outline"
            type="gray"
          >
            <div style={{ padding: "1rem" }}>
              <FormExtraItem
                icon="minor_crash"
                title="Special Delivery Guranteed"
                price="Only ￡10.95"
                description="Lorem ipsum dolor sit amet consectetur adipisicing elit Lorem ipsum dolor sit amet consectetur adipisicing elit"
                active={true}
              />
              <FormExtraItem
                icon="star"
                title="Special Delivery Guranteed"
                price="Only ￡10.95"
                description="Lorem ipsum dolor sit amet consectetur adipisicing elit Lorem ipsum dolor sit amet consectetur adipisicing elit"
                active={false}
                style={{ marginTop: "1rem" }}
              />
            </div>
          </Collapsible>
        </div>
      </div>
      <div
        style={{
          marginTop: "3rem",
          flexWrap: "wrap",
          justifyContent: "space-around",
        }}
        className="d-flex align-center"
      >
        {Basic()}
      </div>
      <ButtonRound
        text="Notification"
        style={{ padding: "0 3rem" }}
        onClick={() => {
          dispatch(
            showNotification(
              "Lorem ipsum dolor sit amet consectetur adipisicing elit"
            )
          );
        }}
      />
    </div>
  );
};

export { Demo, Demo as default };
